import { render } from "./App.vue?vue&type=template&id=0b609972"
const script = {}

import "./App.vue?vue&type=style&index=0&id=0b609972&lang=scss"

import exportComponent from "C:\\Users\\Administrator\\Desktop\\projects\\p2ipo-system-v2\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__